import React from 'react';
import { cx } from '../cx';

// temp_ColorInput — 임시 공통 컴포넌트(UI파트 검수 후 승격 대상). 처음 쓴 곳: 인디포트폴리오 AI 시공사례.
// 색 직접 고르기(브라우저 색 선택기). ui-core 에 색 입력이 없다.
export interface TempColorInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'value' | 'onChange'> {
  /** #RRGGBB */
  value: string;
  onChange: (hex: string) => void;
  /** 접근성 이름 — 화면에 글자가 없을 때 필수 */
  label: string;
}

export function Temp_ColorInput({ value, onChange, label, className = '', ...props }: TempColorInputProps) {
  return (
    <input
      type="color"
      aria-label={label}
      className={cx(
        'cursor-pointer',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-group',
        className,
      )}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      {...props}
    />
  );
}
